import React from 'react'
import PropTypes from 'prop-types'
import PrivacyWarningContainer from 'LiveBoard/containers/PrivacyWarningContainer'
import { Header } from './Header'
import { Banner } from 'LiveBoard/components/shared/Banner'
import { GreetingCard } from './GreetingCard'
import { SellerCard } from './SellerCard'
import { GoToContent } from './Banner/GoToContent'
import { LiveEventContainer } from 'LiveBoard/components/shared/LiveEvent'
import isEmpty from 'lodash/isEmpty'

import style from './style.css.scss'

const LiveBoard = (props) => {
  const {
    children,
    lead,
    presenter,
    isItemView,
    isGreetingOpen,
    onGreetingCardClose,
    campaign: {
      board_id: boardId,
      general,
      header,
      footer,
      contact_card: contactCard,
      banner,
      themeColorHex,
      bannerTextColorHex,
      headerTextColorHex,
      live_event: liveEvent
    }
  } = props

  const campaignContainerStyle =  {
    paddingBottom: `${isItemView ? style.itemViewerNavPanelHeight : (
      contactCard.card.show ? style.sellerCardHeight : 0
    )}px`
  }

  return (
    <main className="live-board-mobile">
      <PrivacyWarningContainer />
      { isGreetingOpen &&
        <GreetingCard
          lead={lead}
          config={general.greetings}
          onClose={onGreetingCardClose}
          logo={header.logo}
          seller={presenter}
          banner={banner}
          themeColorHex={themeColorHex}
          textColor={bannerTextColorHex} />
      }
      <div
        className={`campaign-container ${isItemView ? 'item-viewer-open' : ''}`}
        style={campaignContainerStyle}>
        { header.show &&
          <Header
            config={header}
            banner={banner}
            themeColorHex={themeColorHex}
            textColor={headerTextColorHex}
            shouldStickToTop={true} /> }
          <Banner
            showHeader={header.show}
            config={banner}
            themeColorHex={themeColorHex}
            textColor={bannerTextColorHex}
            isItemView={isItemView}
            isMobile={true} >
            <GoToContent textColor={bannerTextColorHex} />
          </Banner>
          {!isEmpty(liveEvent) && liveEvent.show && (
            <LiveEventContainer
              boardId={boardId}
              liveEventConfiguration={liveEvent}
              themeColorHex={themeColorHex}
              isMobile={true} />
            )
          }
          { children }
          { !isItemView && contactCard.card.show &&
            <SellerCard
              config={contactCard.card}
              lead={lead}
              seller={presenter}
              themeColorHex={themeColorHex} /> }
      </div>
    </main>
  )
}

LiveBoard.propTypes = {
  campaign: PropTypes.object.isRequired,
  lead: PropTypes.object,
  presenter: PropTypes.object,
  children: PropTypes.object.isRequired,
  isItemView: PropTypes.bool,
  isGreetingOpen: PropTypes.bool.isRequired,
  onGreetingCardClose: PropTypes.func,
  themeColorHex: PropTypes.string
}

export default LiveBoard
